module.exports = __webpack_public_path__ + "img/shape-footer-desktop-total.4735386a01dfdb56d73551ae717e3f67.svg";